import { ChangeDetectorRef, Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { TicketsAssignService } from '../../tickets-assign.service';
import { TicketsService } from '../services/tickets.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-ticket-communicator-info-new',
  templateUrl: './ticket-communicator-info.component.html',
  styleUrls: ['./ticket-communicator-info.component.scss'],
  providers: [TicketsService],
  standalone: false,
})
export class TicketCommunicatorInfoComponent {
  public moment = require('moment');
  public gpDopInfo$: Observable<any>;
  public isShowBlock = false;
  public loading = false;
  _ticket;

  @Input()
  set ticket(ticket) {
    if (!ticket) {
      return;
    }

    this._ticket = ticket;

    this.isShowBlock = (ticket.ticket_type && ticket.ticket_type.id === 4) || this.ticketsService.checkGPInterval(ticket.hd_schedule_intbegin, ticket.hd_schedule_intend);

    if (this.isShowBlock) {
      this.getGPDopInfo();
    }
  }

  get ticket() {
    return this._ticket;
  }

  constructor(
    private ticketsAssignService: TicketsAssignService,
    private cdr: ChangeDetectorRef,
    private ticketsService: TicketsService
  ) {}

  getGPDopInfo(): void {
    this.gpDopInfo$ = this.ticketsAssignService.getTicketGPDopInfo(this.ticket.hd_ticket_number).pipe(finalize(() => this.cdr.detectChanges()));
  }
}
